<template>
	<ParamWrapper v-bind="wrapperProps" hideTitle>
		<div class="params_list_container">
			<div class="width-100 flex-column flex-centerize mt-6">
				<v-btn v-if="!readonly" color="primary" @click="showEditor = true">{{ btnLabel }}</v-btn>
				<span class="mt-2" style="font-size: 11px">
					In the template just "[[" and "]]" to wrap your variables, such as: <b>[[name]]</b>. <br />
				</span>
			</div>
			<p>&nbsp;</p>
			<div class="width-100 mt-3 mb-2" style="font-size: 16px; font-weight: 600" v-if="htmlPreview && htmlPreview.length > 0">
				Map variables
			</div>
			<div :key="tag" v-for="tag in insertDataTags">
				<div class="display-flex flex-row width-100 flex-align-center">
					<div style="width: 120px">{{ tag }}</div>
					<StringParamType
						:templateValue="tagsValues[tag] || ''"
						@update-input-field="(v) => updateInputField(tag, v)"
						v-bind="componentProps"
						:param="genericParam"
						style="width: 320px"
						forceTemplateValue
						:readonly="readonly"
					/>
				</div>
			</div>
			<div class="mt-9 width-100 flex-centerize">
				<v-btn
					style="background: green !important; color: white !important"
					class="mt-6"
					v-if="htmlPreview && htmlPreview.length > 0"
					@click="emailPreviewDialog = true"
					>Show Email preview</v-btn
				>
			</div>
		</div>

		<v-dialog v-model="showEditor" width="1400" height="820">
			<v-card>
				<v-card-text>
					<EmailEditor
						:minHeight="'1000'"
						:options="emailEditorOptions"
						ref="emailEditor"
						v-on:load="editorLoaded"
						v-on:ready="editorReady"
					/>
				</v-card-text>
				<v-card-actions class="justify-center">
					<v-btn text @click="exportHtml">Save & Close</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-dialog v-model="emailPreviewDialog" width="60%">
			<iframe :srcdoc="htmlPreview" style="width: 100%; height: 100%" ref="emailPreview"></iframe>
		</v-dialog>
	</ParamWrapper>
</template>

<script>
import { mapGetters } from 'vuex';
import { EmailEditor } from 'vue-email-editor';
import ParamsService from '@/utils/ParamsService';
import ParamTypeMixin from './mixins/ParamTypeMixin';
import { getNodeTestResult } from '@/store/modules/nodes/getters';
import StringParamType from '@/components/BlockEditor/BlockEditorParams/ParamTypes/StringParamType.vue';
const { PLY_PARAMS } = ParamsService;

export default {
	name: 'EmailTemplatesParamType',
	mixins: [ParamTypeMixin],
	components: {
		EmailEditor,
		StringParamType,
	},
	data: () => ({
		showEditor: false,
		emailPreviewDialog: false,
	}),
	computed: {
		...mapGetters([getNodeTestResult.fullPath]),
		nodeTestResponse() {
			return this[getNodeTestResult.fullPath](this.node.id);
		},
		htmlPreview() {
			return this.nodeTestResponse?.processedTemplate;
		},
		tagsValues() {
			return this.localValue?.tagsValues || {};
		},
		componentProps() {
			return {
				...this.$attrs,
				node: this.node,
				action: this.action,
				isTemplateMode: true,
				service: this.service,
				readonly: this.readonly,
				acceptSingleValue: false,
				isFocused: this.isFocused,
				showDataMenu: this.showDataMenu,
			};
		},
		genericParam() {
			return {
				...this.param,
				...PLY_PARAMS.emailTemplatesParam,
				name: '',
				required: false,
				description: '',
			};
		},
		btnLabel() {
			return this.localValue?.html ? 'Edit email template' : 'Create an email template';
		},
		emailEditorOptions() {
			return {
				designTagsConfig: {
					delimiter: ['^^', '^^'],
				},
			};
		},

		insertDataTags() {
			if (!this.localValue?.html) {
				return [];
			}
			const tagsRegex = /(\[\[(?<tag>\w+)\]\])/gm;
			const tagsRegexResult = [...this.localValue?.html.matchAll(tagsRegex)];
			const tagsFound = tagsRegexResult.map((regexResult) => regexResult.groups.tag);
			return Array.from(new Set(tagsFound)); // This will return unique list.
		},
	},
	methods: {
		updateInputField(tag, v) {
			if (!this.localValue?.tagsValues) {
				this.localValue = { ...this.localValue, tagsValues: {} };
			}
			this.localValue = { ...this.localValue, tagsValues: { ...this.localValue.tagsValues, [tag]: v.map.value } };
		},

		editorLoaded() {
			this.$refs.emailEditor.$el.style.height = '800px';
		},
		// called when the editor has finished loading
		editorReady() {
			if (this.localValue?.design) {
				this.$refs.emailEditor.loadDesign(this.localValue.design);
			}
		},
		saveDesign() {
			this.$refs.emailEditor.editor.saveDesign((design) => {
				console.log('saveDesign', design);
			});
		},
		exportHtml() {
			this.$refs.emailEditor.editor.exportHtml((data) => {
				const { tagsValues } = this.localValue || {};
				this.localValue = {
					tagsValues,
					...data,
				};
				this.showEditor = false;
			});
		},
	},
};
</script>
<style lang="scss" scoped>
iframe {
	min-height: 800px;
}
</style>
